import { Pagination } from "src/app/core/utils/pagination.entity";
import { ClaimData } from "./claim-data.entity";

export abstract class ClaimPagination extends Pagination<ClaimData[]> {}